import { render, staticRenderFns } from "./OrdiniList.vue?vue&type=template&id=09900e51"
import script from "./OrdiniList.vue?vue&type=script&lang=ts"
export * from "./OrdiniList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09900e51')) {
      api.createRecord('09900e51', component.options)
    } else {
      api.reload('09900e51', component.options)
    }
    module.hot.accept("./OrdiniList.vue?vue&type=template&id=09900e51", function () {
      api.rerender('09900e51', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OrdiniList.vue"
export default component.exports